module.exports = __webpack_public_path__ + "static/media/Ryan Schmidt.47032e02.png";